import dayjs from 'dayjs'

export default function datetime(date) {
  return date ? dayjs(date).format('MMM D, YYYY・hh:mm a') : '–'
}
